import React, { Component } from "react";
import { Container, Row } from "reactstrap";
import axios from "../../axios";
import "./Login.css";
import Logo from "../../components/Logo/Logo";
import LoginSide from "../../components/LoginSide/LoginSide";
import ChangePasswordUI from "../../components/ChangePasswordUI/ChangePasswordUI";
import * as url from "../../utils/url";
import { connect } from "react-redux";
import { isMobile } from "../../utils/deviceInfo";
import { isTrivvyProduct, TRIVIA_DESCRIPTION } from "../../utils/constants";

class ChangePassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      confirmPassword: {
        value: null,
        error: false,
      },
      password: {
        value: null,
        error: false,
      },
      errorMessage: "",
    };
  }

  submitUpdatedPassword = (password) => {
    // console.log(this.props);
    const { profile } = this.props.user;
    axios
      .put(url.changePassword, { password: password, email: profile.email })
      .then(() => {
        if (
          profile.organizationId &&
          profile.organizationId.isSignedUpFromTrivvyWebsite
        ) {
          this.props.history.replace("/setup/personal-details");
        } else {
          this.props.history.replace("/setup/welcome");
        }

        // if(profile.orgAdmin) {
        // 	this.props.history.push('/setup/welcome');
        // } else {
        // 	this.props.history.push('/setup/welcome');
        // }
      })
      .catch((error) => {
        this.setState({ ...this.state, errorMessage: error.response.data });
      });
  };

  render() {
    const fromTrivvy =
      isTrivvyProduct() ||
      this.props.user.profile.organizationId.isSignedUpFromTrivvyWebsite;
    return (
      <Container className="login-layout-container">
        <Row className="login-outer-wrapper">
          <div id="login-main" className="col-sm-10 col-md-9 login-card-box">
            <div id="login-main-wrapper" className="white-background">
              {isTrivvyProduct() ? (
                <div className="text-center forgot-pass-trivvy">
                  <span
                    className="sidebar-trivvy-logo-txt "
                    data-tip={TRIVIA_DESCRIPTION}
                  >
                    Trivvy
                  </span>
                </div>
              ) : (
                <Logo />
              )}
              <ChangePasswordUI
                title="Change Your Password"
                desc="Your current password is a temporary password.
								Please change this Password to a more secure one"
                onSubmitPassword={this.submitUpdatedPassword}
                errorMessage={this.state.errorMessage}
              />
            </div>
          </div>
          {!isMobile && !fromTrivvy && <LoginSide />}
        </Row>
        <Row>
          <div id="login-secondary" className="col-sm-12 mb10 pl30">
            <div className="text-center">
              © {new Date().getFullYear()}{" "}
              {fromTrivvy ? (
                <a href="https://www.gotrivvy.com/">Trivvy</a>
              ) : (
                <a href="https://www.ouroffice.io/">OurOffice, Inc</a>
              )}
            </div>
          </div>
        </Row>
      </Container>
    );
  }
}

const mapStateToProps = (state) => {
  // console.log('State after Login', state);
  return {
    user: state.user,
  };
};

export default connect(mapStateToProps)(ChangePassword);
